import { useState } from "react";
import { format, subMonths } from "date-fns";
import { CompletionChart } from "./components/CompletionChart";
import { DateSelector } from "./components/DateSelector";
import { MetricsOverview } from "./components/MetricsOverview";
import { ViewersChart } from "./components/ViewersChart";

interface AnalyticsTabProps {
  signedId: string;
}

export const AnalyticsTab = ({ signedId }: AnalyticsTabProps) => {
  const [startDate, setStartDate] = useState<string>(
    format(subMonths(new Date(), 3), "yyyy-MM-dd"),
  );
  const [endDate, setEndDate] = useState<string>(
    format(new Date(), "yyyy-MM-dd"),
  );
  const [dateGrouping, setDateGrouping] = useState<string>("weekly");

  const handleDateFiltersChange = (
    newStartDate: string,
    newEndDate: string,
    newGrouping: string,
  ) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setDateGrouping(newGrouping);
  };

  return (
    <div className="mx-auto w-full p-3 md:w-5/6 md:p-6">
      <DateSelector onChange={handleDateFiltersChange} />
      <MetricsOverview
        signedId={signedId}
        startDate={startDate}
        endDate={endDate}
        dateGrouping={dateGrouping}
      />
      <ViewersChart />
      <CompletionChart />
    </div>
  );
};
